import React from "react"

import { connect } from "scrivito"
import { ProductPosition } from "shared/types/ProductPosition"
import { RowRendererProps } from "shared/ui/table/types"

import { ProductPositionTableProductPositionRow } from "./ProductPositionTableProductPositionRow"
import { useProductPositionTableProductPositionRowModel } from "./hooks/useProductPositionTableProductPositionRowModel"

export interface ProductPositionTableRowPayload {
  hideQuantity?: boolean
  pendingProjectChildren?: string[]
  showClarificationRequestColumn?: boolean
  showSelectionCheckbox?: boolean
  columnPreset?: "default" | "selection"
  projectID?: string | null
  isReadonly?: boolean
}

export interface ProductPositionTableProductPositionRowConnectorProps
  extends RowRendererProps<ProductPosition> {}

export function ProductPositionTableProductPositionRowConnectorComponent(
  props: ProductPositionTableProductPositionRowConnectorProps
) {
  return (
    <ProductPositionTableProductPositionRow
      {...useProductPositionTableProductPositionRowModel(props)}
    />
  )
}
export const ProductPositionTableProductPositionRowConnector = React.memo(
  connect(ProductPositionTableProductPositionRowConnectorComponent)
) as typeof ProductPositionTableProductPositionRowConnectorComponent
